import { Fragment, useState, useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Pass from "bodycodi/cmap/app/components/common/pass";
import PassEmpty from "bodycodi/cmap/app/components/common/passEmpty";
import bpay_icon from "bodycodi/cmap/app/svg/bpay_icon.svg";

type PlaceTabProp = {
  PlacePassList: Array<any>;
  setActive: Function;
  openPassConfirmPop: () => void;
};

const PlaceTab = ({ PlacePassList, setActive, openPassConfirmPop }: PlaceTabProp) => {
  const [open, setOpen] = useState<boolean>(false);
  const [swiper, setSwiper] = useState<any>({});
  const dotWrap = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setActive(PlacePassList[0]);
  }, [PlacePassList]);

  const slideChange = () => {
    const index = swiper.activeIndex;
    const children = dotWrap.current?.querySelectorAll(".dot")!;
    for (let i = 0; i < children.length; i++) {
      children[i].classList.remove("active1");
    }
    children[index].classList.add("active1");
    setActive(PlacePassList[index]);
  };

  if (PlacePassList.length === 0) {
    return <PassEmpty />;
  }

  const placePassList = PlacePassList.map((d: any) => {
    return (
      <SwiperSlide key={d.seqPassInfo}>
        <Pass d={d} isAdd={false} open={open} setOpen={setOpen} />
      </SwiperSlide>
    );
  });

  const placeDotList = PlacePassList.map((d: any, i: number) => {
    return <div className={"dot" + (i === 0 ? " active1" : "")} key={i}></div>;
  });

  return (
    <Fragment>
      <Swiper
        onSwiper={(swiper) => {
          setSwiper(swiper);
        }}
        onSlideChange={slideChange}
      >
        {placePassList}
      </Swiper>
      <div className="member-pass-list-dot-wrap" ref={dotWrap}>
        {placePassList.length > 1 && <div className="dot-wrap">{placeDotList}</div>}
      </div>
      <button className="member-btn active" onClick={openPassConfirmPop}>
        <img src={bpay_icon} />
        앱결제 요청
      </button>
    </Fragment>
  );
};

export default PlaceTab;
